import { ParsedUrlQuery } from 'querystring';

export function getBeds(query: ParsedUrlQuery) {
    const searchPath = query['search-path'];

    if (searchPath?.includes('studio')) {
        return '0';
    }

    const bedroomsRegex = /(?<bedrooms>\d+)-(bedrooms?)/;
    const bedroomPathMatch = Array.isArray(searchPath)
        ? searchPath.join().match(bedroomsRegex)
        : searchPath?.match(bedroomsRegex);

    if (!bedroomPathMatch) {
        return '';
    }

    return (
        (bedroomPathMatch.groups && bedroomPathMatch.groups['bedrooms']) || ''
    );
}
